<!--
 * @Author: 刘小博
 * @Date: 2023-01-03 10:44:19
 * @LastEditTime: 2023-05-12 18:58:47
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\components\pagination\Pagination.vue
 * 文件备注
-->
<template>
  <!-- <a-spin :spinning="loading"> -->
  <div class="pagination" v-if="pagination">
    <a-button
      icon="left"
      :disabled="leftDisabled"
      class="btn"
      @click="onChangePage('left')"
    >
    </a-button>
    <div class="page">{{ pagination.current ? pagination.current : 1 }}</div>
    <a-button
      icon="right"
      :disabled="rightDisabled"
      class="btn"
      @click="onChangePage('right')"
    >
    </a-button>

    <div class="jumper">
      <span class="text">共{{ pagination.totalPage }}页</span>
      前往
      <a-input
        oninput="value=value.replace('-','')"
        style="width: 50px; margin: 0 5px"
        v-model="jumperPage"
        @pressEnter="onChangePage('jumper')"
        @blur="onChangePage('jumper')"
      ></a-input>
      页
    </div>
  </div>
  <!-- </a-spin> -->
</template>

<script>
import { debounce } from '@/utils/util'
export default {
  props: {
    //分页信息，参考ant-design
    pagination: {
      type: [Object, Boolean],
      default: false
      // require:true
      // {
      //   total // 总数  优化后可以不用
      //   pageSize // 总页数
      //   current // 当前页
      // }
    }
    // loading: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data() {
    return {
      jumperPage: '1', //跳转页面
      count: 0, //计数器，用于记录连续点击的次数
      timer: null //定时器
    }
  },
  methods: {
    onChangePage(type) {
      let jumperPage = Number(this.jumperPage)
      let initDirection = type
      if (type == 'left') this.count--
      if (type == 'right') this.count++
      console.log(this.count, 'count')

      if (this.timer) {
        clearTimeout(this.timer) //清除上次请求计时器
      }
      this.timer = setTimeout(() => {
        switch (initDirection) {
          case 'left':
            let current = 0
            if (this.pagination.current + this.count > 0) {
              current = this.pagination.current + this.count
            } else {
              current = 1
            }

            this.$emit('change', {
              pageSize: this.pagination.pageSize,
              current
            })

            this.count = 0 //计数器清零
            initDirection = ''
            break
          case 'right':
            this.$emit('change', {
              pageSize: this.pagination.pageSize,
              current:
                this.pagination.current + this.count < this.pagination.totalPage
                  ? this.pagination.current + this.count
                  : this.pagination.totalPage
            })

            this.count = 0 //计数器清零
            initDirection = ''
            break
          case 'jumper':
            if (!jumperPage && jumperPage !== 0) {
              return
            } else if (jumperPage == 0) {
              this.jumperPage = 1
              this.$emit('change', {
                pageSize: this.pagination.pageSize,
                current: 1
              })
            } else if (jumperPage > this.pagination.totalPage) {
              this.$emit('change', {
                pageSize: this.pagination.pageSize,
                current: this.pagination.totalPage
              })
              this.jumperPage = this.pagination.totalPage
              // return this.$message.error('不存在对应页码')
            } else {
              this.$emit('change', {
                pageSize: this.pagination.pageSize,
                current: jumperPage
              })
            }
          default: //计数器清零
            this.count = 0
            initDirection = ''
            break
        }
      }, 500)
    }
  },
  computed: {
    /**
     * 左侧按钮是否禁用
     */
    leftDisabled() {
      if (this.pagination) {
        return this.pagination.current === 1
      } else {
        return true
      }
    },
    /**
     * 右侧按钮是否禁用
     */
    rightDisabled() {
      if (this.pagination) {
        return this.pagination.current === this.pagination.totalPage
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped lang="less">
.pagination {
  display: flex;
  float: right;
  margin-top: 10px;
  bottom: 5px;

  .page {
    min-width: 32px;
    height: 32px;
    color: #1890ff;
    text-align: center;
    line-height: 32px;
    border-radius: 4px;
    border: 1px solid #1890ff;
    background: #fff;
    margin: 0 8px;
    cursor: pointer;
  }

  .btn {
    font-size: 14px;
  }

  .jumper {
    margin-left: 10px;
    display: flex;
    align-items: center;

    .text {
      margin-right: 10px;
    }
  }
}
</style>
